import { all, fork } from 'redux-saga/effects';
import { ACTIVATE, DEACTIVATE } from './actions';
import loginAndPasswordSaga from './components/LoginAndPassword/sagas';
import codeSaga from './components/Code/sagas';
import { tracked } from '../../utils/sagaWrappers';

function* saga() {
  yield all([fork(loginAndPasswordSaga), fork(codeSaga)]);
}

export default tracked(saga, ACTIVATE, DEACTIVATE);
